import _ from 'lodash';
import { bigQuery } from '@fiverr-private/obs';

export const sendBigQueryEvents = (events) => {
    if (!events || _.isEmpty(events)) {
        return;
    }

    bigQuery.send(...events);
};
